
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Зафиксировать',
	'find_label': 'Найти',
	'findCancelLabel': 'Отмена',
	'sourcePaneLabel': 'Выбранные источники',
	'sourcePaneContentLabel': 'Выбрать источник',
	'addDataDashboardCoachMarkContents': 'Перетащите данные из панели данных на сводную панель.',
	'addDataStoryCoachMarkContents': 'Перетащите данные из панели данных на историю.',
	'addDataCoachMarkTitle': 'Добавить данные',
	'selectSourcesText': 'Выберите и добавьте источник данных, чтобы построить приложение %{app}',
	'selectSourcesLabel': 'Выбрать источник',
	'errorSourcesTitle': 'Не удалось загрузить дерево данных',
	'errorLoadingDataSources': 'Произошла ошибка при загрузке списка наборов данных',
	'errorLoadingDataTree': 'Произошла ошибка при загрузке дерева',
	'dataSetPaneLastUpdated': 'Последнее обновление: %{date}',
	'dataSourcePaneDateUnknown': 'Неизвестно',
	'moreTitle': 'Дополнительно',
	'backLabel': 'Перейти назад',
	'addDataSourceDialogTitle': 'Добавить источник данных',
	'addDataSourceDialogButtonLabel': 'Добавить',
	'dlg_use': 'Использовать',
	'dlg_RelinkDataSourceTitle': 'Заменить набор данных \'%{dataSourceName}\' на ...',
	'propertiesDialogTitle': 'Свойства',
	'missingDataSetData': 'Данные для этого набора данных недоступны. Обновите набор данных или обратитесь к своему администратору, чтобы получить доступ к источнику.',
	'errorLoadingSource': 'Метаданные для \'%{sourceName}\' не загрузились. Обратитесь к администратору для получения более подробной информации.',
	'errorMessageTitle': 'Ошибка',
	'calculation_navigation_in_use': 'При удалении вычислений или путей навигации все визуализации, ссылающиеся на удаленный элемент, становятся недействительными. Вы действительно хотите выполнить удаление?',
	'delete_confirm': 'Подтвердить удаление',
	'previewUnavailable': 'Лоток данных и глобальные фильтры недоступны для этого типа пакета.',
	'contextualGridTabName': 'Визуализация данных',
	'DATA_TRAY_no_data_text': '\'Здесь будут показаны ваши данные.\'',
	'contextualGridMenuLabel': 'Меню данных визуализации',
	'contextualGridExport': 'Экспорт',
	'nullValueText': 'Пустое значение',
	'forecastDetailsTabName': 'Прогнозирование статистических данных',
	'forecastDetailsModelLabel': 'Модель',
	'forecastDetailsQualityMetricLabel': 'Показатели точности',
	'forecastDetailsSmoothingCoefLabel': 'Параметры',
	'forecastDetailsDiagnostics': 'Диагностика',
	'forecastDetailsForecastLabel': 'Прогноз',
	'forecastDetailsStatusLabel': 'Состояние',
	'forecastDetailsAccuracyPercentLabel': 'Точность в %',
	'forecastDetailsTrendLabel': 'Тенденция',
	'forecastDetailsSeasonLabel': 'Сезонность',
	'forecastDetailsSeasonalPeriodLabel': 'Сезонный период',
	'forecastDetailsAlphaLabel': 'Альфа',
	'forecastDetailsBetaLabel': 'Бета',
	'forecastDetailsGammaLabel': 'Гамма',
	'forecastDetailsPhiLabel': 'Фи',
	'forecastDetailsMissingCount': 'Число пропущенных',
	'forecastDetailsSeriesLengthLabel': 'Длина ряда',
	'forecastDetailsIgnoredPeriods': 'Проигнорированные периоды',
	'forecastDetailsTrendStrength': 'Сила тенденции',
	'forecastDetailsSeasonalityStrength': 'Сила сезонности',
	'forecastDetailsTimeDeltaUnit': 'Интервал даты / времени',
	'forecastDetailsNotes': 'Примечания'
});
